import React, { useEffect, useMemo, useState } from "react";
import styles from "./AllInfoVkContainer.module.scss";
import Title from "../../../../ui/Title/Title";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../../ui/Button/Button";
import { ClipLoader } from "react-spinners";
import { LinkSlashIcon } from "../../../../assets/icons/LinkSlashIcon";
import { Checkbox } from "../../../../ui/Checkbox/Checkbox";
import { useNavigate } from "react-router-dom";
import Select from "../../../../ui/Select/Select";
import Switcher from "../../../../ui/Switcher/Switcher";
import Chip from "../../../../ui/Chip/Chip";
import {
  setNewVk,
  setUpdateVk,
  setUpdateVkData,
} from "../../../../store/slices/vkSlice.js";
import { ModalVkIntegration } from "../../../ModalVkIntegration/ModalVkIntegration.js";
import { LogoVkIcon } from "../../../../assets/icons/LogoVkIcon.js";
import { deactivateVk } from "../../../../utils/api/actions/integrations/vk.js";
import { ErrorComponent } from "../../../ErrorComponent/ErrorComponent.js";

export const AllInfoVkContainer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { activeVk, newVk, updateVk, isErrorVk } = useSelector(
    (state) => state?.vk
  );
  const { dataAssistants } = useSelector((state) => state?.assistant);

  const initialVkData = useMemo(
    () => ({
      userId: activeVk?.userId,
      assistantId: activeVk?.assistantId,
      groupId: activeVk?.groupId,
      callbackServerActive: activeVk?.callbackServerActive,
    }),
    [activeVk]
  );

  const isAssistantActive = activeVk?.callbackServerActive;

  const [visibleModal, setVisibleModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isSwitchOn, setIsSwitchOn] = useState(isAssistantActive);
  const [updatedVkData, setUpdatedVkData] = useState(initialVkData);
  const [checked, setChecked] = useState(false);

  const isEmptyObject = (obj) => obj && Object.keys(obj).length > 0;

  useEffect(() => {
    // Синхронизация переключателя при изменении Redux-данных
    if (activeVk) {
      setIsSwitchOn(activeVk.callbackServerActive);
    }
  }, [activeVk]);

  useEffect(() => {
    if (!updateVk) {
      setUpdatedVkData(initialVkData);
      setIsSwitchOn(initialVkData.callbackServerActive);
    }
  }, [updateVk, initialVkData]);

  useEffect(() => {
    setUpdatedVkData((prevData) => ({
      ...prevData,
      callbackServerActive: isSwitchOn,
      // assistantId: activeVk?.assistantId || updatedVkData?.assistantId,
    }));
  }, [isSwitchOn]);

  useEffect(() => {
    if (updateVk) {
      dispatch(setUpdateVkData(updatedVkData));
    }
  }, [updateVk, updatedVkData, dispatch]);

  useEffect(() => {
    if (isEmptyObject(newVk)) {
      setVisibleModal(true);
    }
  }, [newVk]);

  const assistantName =
    updatedVkData?.assistantId !== undefined
      ? dataAssistants?.find(
          (assistant) => assistant.id === updatedVkData?.assistantId
        )?.name || "Ассистент не найден"
      : dataAssistants?.find(
          (assistant) => assistant.id === activeVk?.assistantId
        )?.name || "Ассистент не найден";

  const handleToggle = () => {
    const newSwitchState = !isSwitchOn;
    setIsSwitchOn(newSwitchState);

    dispatch(setUpdateVk(true));
    setUpdatedVkData((prevData) => ({
      ...prevData,
      callbackServerActive: newSwitchState,
    }));
  };

  const selectObserver = (val) => {
    dispatch(setUpdateVk(true));
    setUpdatedVkData((prevData) => ({
      ...prevData,
      assistantId: val,
    }));
  };

  const handleDeactivate = () => {
    localStorage.removeItem("dataVk");
    let data = {
      userId: activeVk.userId,
      groupId: activeVk.groupId,
      withRemove: checked,
    };
    dispatch(deactivateVk(data, setLoading, navigate));
  };

  const handlerCloseModal = () => {
    setVisibleModal(false);
    dispatch(setNewVk(null));
  };

  const hiddenKey = (str) => {
    if (str.length <= 8) {
      return str;
    }

    const start = str.slice(0, 4);
    const end = str.slice(-4);

    return `${start} ******** ${end}`;
  };

  const handleStartInit = () => {
    dispatch(
      setNewVk({
        userId: "",
        assistantId: "",
        callbackServerActive: "",
        groupId: "",
      })
    );
    setVisibleModal(true);
  };

  const DataItem = ({ title, data, chip }) => {
    return (
      <div className={styles.dataItemContainer}>
        <div className={styles.dataItemContainerFlex}>
          <label className={styles.title}>{title}</label>
          {chip && (
            <Chip
              classNameChip={styles.chipContainer}
              active={isSwitchOn}
              title={isSwitchOn ? "Активен" : "Не активен"}
            />
          )}
        </div>
        <label className={styles.data}>{data}</label>
      </div>
    );
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.headerInfoContainer}>
          {!isErrorVk && (
            <div className={styles.headerInfoContainerTitle}>
              <Title title={activeVk?.name} className={styles.title} />
              <LogoVkIcon fillF={"#0077FF"} fillS={"white"} />
            </div>
          )}
          {isErrorVk && (
            <ErrorComponent
              title={"Произошла ошибка при получении данных ВКонтакте"}
              text={
                "При получении данных о вашем аккаунте произошла ошибка. Вы можете вернуться на страницу интеграций и попробовать открыть страницу еще раз."
              }
              buttonTitle={"Вернуться на страницу интеграций"}
              path={"/integration"}
            />
          )}
          {activeVk && !activeVk?.active && !isErrorVk ? (
            <Button
              leftIcon={
                loading ? (
                  <ClipLoader size={15} color="white" />
                ) : (
                  <LinkSlashIcon />
                )
              }
              titleClassName={styles.buttonTitle}
              className={styles.button}
              title={loading ? "Подождите" : "Привязать"}
              onClick={handleStartInit}
            />
          ) : (
            !isErrorVk && (
              <>
                <Button
                  leftIcon={
                    loading ? (
                      <ClipLoader size={15} color="white" />
                    ) : (
                      <LinkSlashIcon />
                    )
                  }
                  titleClassName={
                    loading ? styles.activeButtonTitle : styles.buttonTitle
                  }
                  className={loading ? styles.activeButton : styles.button}
                  title={loading ? "Подождите" : "Отвязать"}
                  onClick={handleDeactivate}
                />
                <Checkbox
                  value={checked}
                  onChange={(e) => setChecked(e.target.checked)}
                />
              </>
            )
          )}
        </div>
      </div>

      {activeVk && !isErrorVk && (
        <>
          <div className={styles.rowData}>
            <DataItem title={"Group id"} data={activeVk.groupId} />
            {activeVk && (
              <DataItem
                title={"Group key"}
                data={hiddenKey(activeVk.groupKey)}
              />
            )}
          </div>
          <div className={styles.rowData}>
            <DataItem title={"Короткое имя"} data={activeVk.screenName} />
          </div>
        </>
      )}
      {activeVk && !isErrorVk && (
        <div className={styles.headerAssistantContainer}>
          <DataItem
            title={`Ассистент`}
            chip={true}
            data={
              <Select
                containerStyle={styles.containerSelect}
                labelStyle={styles.labelSelect}
                dataSelect={dataAssistants}
                selectObserver={selectObserver}
                nameSelectedOption={assistantName}
              />
            }
          />
          <div>
            <DataItem
              title={"Статус"}
              data={
                <Switcher
                  switchStyle={styles.switchContainer}
                  bool={isSwitchOn}
                  onToggle={handleToggle}
                />
              }
            />
          </div>
        </div>
      )}
      {newVk && !isErrorVk && (
        <ModalVkIntegration
          visible={visibleModal}
          handlerClose={handlerCloseModal}
        />
      )}
    </div>
  );
};
